var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ov)?_c('span',{staticClass:"j-sensitive-wrap"},[_vm._v(" "+_vm._s(_vm.eyeStyle === 'close' ? _vm.nv : _vm.ov)+" "),(_vm.eye && _vm.ov)?_c('i',{class:("j-sensitive-eye-" + _vm.eyeStyle),on:{"click":_vm.eyeChange}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }